// test1812
(1812 && 0);
